module.exports = __webpack_public_path__ + "static/img/4-深业集团.92d719d7.png";